import { ItemDisplayValue } from "../item-display-value/item-display-value";

export const ItemDisplayDocument = ({ item }) => {
  return (
    <>{item.documentId ? <ItemDisplayValue label="ID dokumenta" value={item.documentId} /> : "Nepoznat ID dokumenta"}</>
  );
};
